import ThingToHtml from './thing-to-html'

export default ThingToHtml
